import type { FieldValues, Path, PathValue, UseFormReturn } from "react-hook-form";
import { Select, type SelectOption } from "../../form";
import type { SelectRenderOption } from "../../form/select";
import { DataTableInputWrapper } from "./data-table-input-wrapper";

/** Props Interface */
interface DataTableSelectProps<T extends FieldValues, U, V> {
	options: Array<SelectOption<U, V>>;
	methods: UseFormReturn<T>;
	name: Path<T>;
	renderOption: SelectRenderOption<U, V>;
	isDisabled?: boolean;
	multiple?: boolean;
	max?: number;
	multipleSelectionRender?: (items: Array<SelectOption<U, V>>) => React.JSX.Element;
	onChange?: (value: PathValue<T, Path<T>>) => void;
	"data-cy"?: string;
}

export function DataTableSelect<T extends FieldValues, U, V>({
	options,
	methods,
	name,
	renderOption,
	isDisabled,
	multiple,
	max,
	multipleSelectionRender,
	onChange,
	"data-cy": dataCy,
}: DataTableSelectProps<T, U, V>) {
	/** Render */
	return (
		<DataTableInputWrapper>
			<Select
				className="w-full! h-full! rounded-none! border-none! shadow-none! bg-transparent! peer"
				control={methods.control}
				name={name}
				itemNotFoundLabel="Not found"
				options={options}
				onChange={onChange}
				label={undefined}
				isRequired={false}
				isNullable={false}
				renderOption={renderOption}
				isDisabled={isDisabled}
				multiple={multiple}
				multipleSelectionRender={multipleSelectionRender}
				max={max}
				data-cy={dataCy}
			/>
		</DataTableInputWrapper>
	);
}
